module.exports = __webpack_public_path__ + "img/default-profile.5a021ab9.png";